import React from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CityComponents = ({cityData, onClose }) => {
  console.log("city-Data:", cityData);
    const formatType = (component) => {
        if (component.artwork) {
          return 'Image Container';
        } else if (component.embed_link) {
          return 'Youtube';
        }else if (component.magazine_url) {
          return 'Magazine';
        } else if (component.point_type === 'External') {
          return 'External Hotspot';
        } else if (component.point_type === 'Internal') {
          return 'Internal Hotspot';
        } else if (component.content) {
          return 'WYSIWYG Editor';
        } else if (component.info_type) {
          return 'This Week in STEM City';
        } else {
          return 'Internal Hotspot';
        }
    };
    
 
  // Function to format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Function to format state
  const formatState = (state) => {
    switch (state) {
      case 'draft':
        return 'Draft';
      case 'in_review':
        return 'In-Review';
      case 'published':
        return 'Published';
      default:
        return state;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Typography variant="h5" gutterBottom>
          City Components
        </Typography>
        <Button variant="contained" onClick={onClose} startIcon={<ArrowBackIcon />} sx={{ bgcolor: 'yellow', color: '#000000' }}>
          Go Back
        </Button>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Created At</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Iterate over room_embedcontainer */}
            {cityData.city_embedcontainer.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>{formatType(component)}</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
            {/* Iterate over room_imagecontainer */}
            {cityData.city_imagecontainer.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>{formatType(component)}</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
            {/* Iterate over room_imagehotspot */}
            {cityData.city_imagehotspot.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>{formatType(component)}</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
            {/* Iterate over room_info */}
            {cityData.city_info.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>{formatType(component)}</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
            {cityData.city_magazine.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>{formatType(component)}</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
            {/* Iterate over room_tinymcecontent */}
            {cityData.city_tinymcecontent.map((component) => (
              <TableRow key={component.id}>
                <TableCell>{component.name}</TableCell>
                <TableCell>{formatDate(component.created_at)}</TableCell>
                <TableCell>WYSIWYG Editor</TableCell>
                <TableCell>{formatState(component.state)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
 
export default CityComponents; 
